export default {"src":"/_next/static/media/down_small.1bf62862.svg","height":17,"width":16};